export default function extractValueFromObject({ object = {}, key }) {
  if (key in object) return object[key];
  return null;
}
